export type WebsiteWorkspaceRole = 'landlord' | 'agent' | 'agency';
export const WORKSPACE_ROLES: WebsiteWorkspaceRole[] = ['landlord', 'agent', 'agency'];
export function workspaceBase(pathname = window.location.pathname): string {
  const role = pathname.split('/')[1];
  return WORKSPACE_ROLES.includes(role as WebsiteWorkspaceRole) ? `/${role}` : '';
}
const aliases: Record<string, string> = {
 '/tenant/subscription':'/account/my-subscription', '/tenant/referrals':'/account/referrals',
 '/tenant/profile':'/profile', '/tenant/verification':'/kyc', '/pricing':'/account/plans',
};
const internal = /^\/(dashboard|properties|property-verification|legal-documents|leads|agency-profile|agency-verification|agents-master|tenant-property-requests|conversations|notifications|documents|profile|change-password|kyc|account|payments|payment-recovery|invoices|checkout|subscription)(?:\/|\?|#|$)/;
export function workspacePath(path: string, base = workspaceBase()): string {
  if (!base || !path.startsWith('/') || path.startsWith('//')) return path;
  const match = path.match(/^([^?#]*)(.*)$/);
  const pathname = match?.[1] ?? path;
  const suffix = match?.[2] ?? '';
  const normalized = aliases[pathname] ?? pathname;
  if (/^\/(landlord|agent|agency)(?:\/|$)/.test(normalized)) return `${base}${normalized.replace(/^\/(landlord|agent|agency)/, '')}${suffix}`;
  return internal.test(normalized) ? `${base}${normalized}${suffix}` : path;
}
